const triggers = [];
const events = ['click'];
const script = document.createElement('script');
script.type = 'text/javascript';
script.async = true;
script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&languages=en,es';
function loadScript() {
  (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
  // Remove the trigger event listeners
  events.forEach(e => {
    triggers.forEach(trigger => {
      trigger.removeEventListener(e, loadScript);
    });
  });
}
DomObserver.observe('.js-google-translate-element-trigger', elements => {
  elements.forEach(trigger => {
    events.forEach(e => {
      trigger.addEventListener(e, loadScript);
      triggers.push(trigger);
    });
  });
});
script.addEventListener('load', () => {
  // Remove the triggers
  triggers.forEach(trigger => {
    trigger.remove();
  });
});
events.forEach(e => {
  triggers.forEach(trigger => {
    trigger.addEventListener(e, loadScript);
  });
});

// If the user has already interacted with the trigger, load the script
if (window.sessionStorage.getItem('google-translate-trigger')) loadScript();